// extracted by mini-css-extract-plugin
module.exports = {"testimonials-section":"Testimonials_testimonials-section__2k3CO","testimonial-wrapper":"Testimonials_testimonial-wrapper__2TBAH"};